<template>
  <div>
    <b-form-group class="lato-regular field-headings" :label="title">
      <!-- <p class="p-0 m-0 text-left text-area-title lato-regular field-headings mb-1">{{title}}</p> -->
      <b-form-textarea
      v-if="allowOnlyNumbers == true"
        :name="title"
        @keydown="inputTextNumbers($event)"
        @keyup="inputTextNumbers($event)"
        :id="title"
        v-validate="validation"
        :state="errors.has(errorMessage) ? false : null"
        :rows="rows"
        :value="value"
        :disabled="disabled"
        :type="type"
        class="width-control-small lato-regular-input m-0"
      ></b-form-textarea>
      <b-form-textarea
      v-if="allowOnlyNumbers == null"
        :name="title"
        @keydown="inputText($event)"
        @keyup="inputText($event)"
        :id="title"
        v-validate="validation"
        :state="errors.has(errorMessage) ? false : null"
        :rows="rows"
        :value="value"
        :disabled="disabled"
        :type="type"
        class="width-control-small lato-regular-input m-0"
      ></b-form-textarea>
      <div
        :class="'helo-block alert alert-danger errorWidthSmall mt-1'"
        v-show="errors.has(title)"
      >{{errors.first(title)}}</div>
    </b-form-group>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["title", "value", "validation", "disabled", "maxCharacter","rows", "type",
    "allowOnlyNumbers"],
  data() {
    return {};
  },
  computed: {},
  created() {
    // console.log(this.className);
  },
  methods: {
    inputText(event) {
      if ( event.key != '!' && event.key != '@' &&
      event.key != '#' && event.key != '$' &&
      event.key != '%' && event.key != '^' &&
      event.key != '&' && event.key != '*' &&
      event.key != '<' && event.key != '>' &&  event.key != '~' && event.key != ';' &&    
        event.target.value.length < 500 && ((event.keyCode >= 48 && 
        event.keyCode <= 57) || (event.keyCode >= 65 && event.keyCode <= 90) ||
        (event.key == "Backspace" ||
          event.key == "Tab" ||
          event.key == "Delete" ||
          event.key == "ArrowLeft" ||
          event.key == "ArrowRight" ||
          event.key == " " || event.key == "Spacebar" 
          || event.key == "Space" || event.key == "." ||
          event.key == "Shift"))
      ) {  
      if (event.target.value.length <= this.maxCharacter) {
        this.$emit("inputChanges", event.target.value);
      } else {
        if (event.keyCode == 8) {
          this.$emit("inputChanges", event.target.value);
          return true;
        } else {
          event.preventDefault();
          return false;
        }
      }      
      } else {
        event.preventDefault();
      }
    },
    inputTextNumbers(event) {
      var key = event.keyCode;
      if (event.target.value.length <= this.maxCharacter) {
        if (
          (key >= 48 && key <= 57) || (key >= 96 && key <= 105) ||
          event.keyCode == 46 ||
          event.keyCode == 8 ||
          event.keyCode == 37 ||
          event.keyCode == 39 ||
          event.keyCode == 32 ||
          event.keyCode == 9
        ) {
          this.$emit("inputChanges", event.target.value);
        } else {
          event.preventDefault();
        }
      } else {
        if (event.keyCode == 8) {
          this.$emit("inputChanges", event.target.value);
          return true;
        } else {
          event.preventDefault();
          return false;
        }
      }
    }
  }
};
</script>
<style scoped>
.form-control:focus {
  box-shadow: none !important;
}

[name="Number of Employees"]{resize: none;max-height:33.5px;width:100%;}
</style>